var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 30.7083C12.375 30.8367 12.3933 30.9467 12.4117 31.075L16.0783 48.4917C16.2433 49.335 16.995 49.9584 17.875 49.9584H48.125C49.005 49.9584 49.7567 49.335 49.9217 48.4917L53.5883 31.075C53.6067 30.9467 53.625 30.8367 53.625 30.7083C53.625 29.7 52.8 28.875 51.7917 28.875H14.2083C13.2 28.875 12.375 29.7 12.375 30.7083Z",
    fill: "#F3F3F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0837 53.6249C48.9057 53.6249 53.6254 48.9052 53.6254 43.0832C53.6254 37.2612 48.9057 32.5415 43.0837 32.5415C37.2617 32.5415 32.542 37.2612 32.542 43.0832C32.542 48.9052 37.2617 53.6249 43.0837 53.6249Z",
    fill: "#FF8E9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2034 48.4917L16.5367 31.075C16.5183 30.9467 16.5 30.8367 16.5 30.7083C16.5 29.7 17.325 28.875 18.3333 28.875H14.2083C13.2 28.875 12.375 29.7 12.375 30.7083C12.375 30.8367 12.3933 30.9467 12.4117 31.075L16.0783 48.4917C16.2433 49.335 16.995 49.9584 17.875 49.9584H22C21.12 49.9584 20.3684 49.335 20.2034 48.4917Z",
    fill: "#D5DBE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 43.0832C36.667 37.9682 40.3117 33.7057 45.1462 32.7468C44.4788 32.6148 43.7895 32.5415 43.0837 32.5415C37.261 32.5415 32.542 37.2605 32.542 43.0832C32.542 48.9059 37.261 53.6249 43.0837 53.6249C43.7895 53.6249 44.4788 53.5534 45.1462 53.4195C40.3117 52.4607 36.667 48.1982 36.667 43.0832Z",
    fill: "#E0475B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0837 54.9998C36.513 54.9998 31.167 49.6538 31.167 43.0832C31.167 36.5125 36.513 31.1665 43.0837 31.1665C49.6543 31.1665 55.0003 36.5125 55.0003 43.0832C55.0003 49.6538 49.6543 54.9998 43.0837 54.9998ZM43.0837 33.9165C38.0292 33.9165 33.917 38.0287 33.917 43.0832C33.917 48.1377 38.0292 52.2498 43.0837 52.2498C48.1382 52.2498 52.2503 48.1377 52.2503 43.0832C52.2503 38.0287 48.1382 33.9165 43.0837 33.9165Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.708 38.0415H44.458V48.1248H41.708V38.0415Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.041 41.7085H48.1243V44.4585H38.041V41.7085Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0866 51.3333H17.875C16.3442 51.3333 15.0205 50.2498 14.729 48.7557L11.066 31.3592C11.0202 31.0585 11 30.8953 11 30.7083C11 28.9392 12.4392 27.5 14.2083 27.5H34.7233V30.25H14.2083C13.959 30.25 13.75 30.459 13.75 30.7083L17.424 48.2093C17.468 48.4312 17.6587 48.5833 17.875 48.5833H28.0866V51.3333Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.0835H55V23.8335H11V21.0835Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0088 21.5034L42.5514 10.5037L44.5369 12.4067L33.9943 23.4064L32.0088 21.5034Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7148 29.1128L22.4236 28.6425L26.0831 49.7221L23.3743 50.1923L19.7148 29.1128Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuEmpty);
export default __webpack_public_path__ + "static/media/MenuEmpty.4557ce8b97702aef07244febf6785e4d.svg";
export { ForwardRef as ReactComponent };